<template>
    <div class="bg_white" >
      <van-nav-bar
      title="答疑解惑"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      >
      <template #right>
          <van-icon name="add-o" size="20"/>
      </template>
      </van-nav-bar>

      <div>
        <van-cell v-for="item in list" :key="item.id" :title="item.contents" is-link :url="'/askDetail?id='+item.id" >
          <van-tag type="success" v-if="item.status==1">已回复</van-tag>
          <van-tag type="primary" v-if="item.status==0">待回复</van-tag>
        </van-cell>
      </div>

    </div>
</template>

<script>
import { getAskList } from '../../api/custom';
export default {
  data() {
    return {
        param:{
          pageNumber:1,
          pageSize:20
        },
        list:[]
    }

   },
   created(){
    this.getList();
   },
   methods: {
    getList(){
      getAskList(this.param).then(res=>{
        if (res.success) {
          this.list = res.data.list
        }
      })
    },
    onClickLeft() {
    this.$router.back()
    },
    onClickRight() {
      this.$router.push("/askAdd")
    },
    
  }

};
</script>

<style lang="less">
.header {
  
  border-bottom: 1px solid #ccc;
  text-align: center;
  width: 100%;
  height: 300px;
  line-height: 450px;
}
.loginbox{
  box-sizing: border-box;
  padding:15px;
  text-align: center;
  
  
}
.header image {
  width: 200px;
  height: 200px;
}

.content {
   margin-left: 20px;
   margin-top: 20px;
  // margin-bottom: 90px;
  font-size: 14px;
  text-align: left;
}
.mt20{
  margin-top: 40px;
}
.content text {
  display: block;
  color: #9d9d9d;
  margin-top: 40px;
}

.bottom {
  border-radius: 80px;
  margin: 70px 50px;
  font-size: 35px;
}

</style>

